import cn from 'classnames'

import Shield from '../../assets/svg/shield.svg'

import styles from './styles.module.scss'

type AuthEnableProps = {
  img?: string
  text?: string
  classNames?: string
  position?: string
}
export default function AuthEnable({ img, text = '', classNames, position }: AuthEnableProps) {
  return (
    <div className={cn(styles.successMessage, position)}>
      <img src={img || Shield} alt="Shield success" className={classNames || styles.successMessage__image} />
      <span className={styles.successMessage__text}>{text}</span>
    </div>
  )
}
